import React from "react";
import { Graphics } from "@pixi/react";
import BorderedSprite from "../BorderedSprite";
import { resourceIconMap } from "./constants";

export const renderResources = (mapGrid, cellSize, scale) => {
  const resources = [];
  const zoomBoost = Math.min(
    3,
    Math.max(1, Math.pow(1 / Math.max(scale || 1, 0.15), 1.25))
  );
  mapGrid.forEach(({ cell, x, y }) => {
    if (!cell || !Array.isArray(cell[5]) || cell[5].length === 0) return;
    const iconSize = cellSize * 0.8 * zoomBoost;
    const spacing = iconSize * 0.7;
    const centerX = x * cellSize + cellSize / 2;
    const centerY = y * cellSize + cellSize / 2;
    const startOffset = -((cell[5].length - 1) * spacing) / 2;
    cell[5].forEach((resource, idx) => {
      const iconName = resourceIconMap[resource] || resource;
      resources.push(
        <BorderedSprite
          key={`resource-${x}-${y}-${resource}`}
          texture={`/${iconName}.png`}
          x={centerX + startOffset + idx * spacing}
          y={centerY}
          width={iconSize}
          height={iconSize}
          borderColor={0x000000}
          borderWidth={1 * Math.sqrt(scale)}
          interactive={true}
          pointerdown={(e) => {
            e.stopPropagation();
            console.log(`Resource clicked: ${resource} at ${x},${y}`);
          }}
          baseZ={50}
        />
      );
    });
  });
  return resources;
};

export const renderResourceCaptureOverlays = (
  mapGrid,
  cellSize,
  ownershipMap,
  resourceNodeClaims,
  captureTicks
) => {
  const overlays = [];
  mapGrid.forEach(({ cell, x, y }) => {
    if (!cell || !Array.isArray(cell[5]) || cell[5].length === 0) return;
    const owner = ownershipMap.get((y << 16) | x);
    if (!owner) return;
    const key = `${x},${y}`;
    const claim = resourceNodeClaims?.[key];
    if (!claim) return;
    const isCaptured = claim.owner === owner;
    const progressOwner = claim.progressOwner;
    if (!isCaptured && progressOwner !== owner) return;
    const progress = Math.min(
      1,
      (claim.progress || 0) / Math.max(1, captureTicks)
    );
    const size = cellSize * 0.9;
    const cx = x * cellSize + cellSize / 2;
    const cy = y * cellSize + cellSize / 2;

    // Use resource-specific icon instead of generic fort
    const resourceType = cell[5][0];
    const iconName = resourceIconMap[resourceType] || resourceType;

    if (isCaptured) {
      overlays.push(
        <BorderedSprite
          key={`capture-building-${key}`}
          texture={`/${iconName}.png`}
          x={cx}
          y={cy + size * 0.05}
          width={size * 0.9}
          height={size * 0.9}
          borderColor={0x6e6e6e}
          borderWidth={1}
          alpha={0.9}
          baseZ={112}
        />
      );
      return;
    }
    overlays.push(
      <Graphics
        key={`capture-${key}`}
        zIndex={115}
        draw={(g) => {
          g.clear();
          const radius = size * 0.48;
          const pieY = cy;
          g.beginFill(0x0f172a, 0.35);
          g.drawCircle(cx, pieY, radius);
          g.endFill();
          g.beginFill(0x34d399, 0.8);
          g.moveTo(cx, pieY);
          const start = -Math.PI / 2;
          const end = start + progress * Math.PI * 2;
          g.arc(cx, pieY, radius, start, end);
          g.lineTo(cx, pieY);
          g.endFill();
        }}
      />
    );
  });
  return overlays;
};
